import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import WordTranslation from "./WordTranslation";
import TranslationWord from "./TranslationWord";
import Sprint from "./Sprint";
import Wordonstructor from "./WordConstructor";
import { setActiveExercise } from "../../../redux/slices/exerciseSlice";
import { fetchUserVocabulary } from "../../../redux/slices/userVocabularySlice";
import { UserContext } from "../../user/UserContext";

import "./VocabularyExercises.css";

export default function ExercisesTab(props) {
  const dispatch = useDispatch(); // Initialize the Redux dispatch function
  const navigate = useNavigate(); // Initialize useNavigate for navigation
  const { userAttributes } = useContext(UserContext);

  const activeExercise = useSelector((state) => state.exercise.activeExercise); // Access the active exercise from the Redux store
  const userWords = useSelector((state) => state.userVocabulary.userWords); // Access the user vocabulary from the Redux store

  const [showNoWordsModal, setShowNoWordsModal] = useState(false); // State to manage the modal visibility

  // Effect to check if the user has no words
  useEffect(() => {
    const fetchAndCheckWords = async () => {
      if (userWords.length === 0) {
        try {
          // Fetch user vocabulary
          const result = await dispatch(
            fetchUserVocabulary({ owner: userAttributes.sub })
          );

          // Check if no words are returned and no error occurred
          if (result.payload && result.payload.length === 0) {
            setShowNoWordsModal(true); // Show the modal if no words were fetched
          }
        } catch (error) {
          console.error("Error fetching user vocabulary:", error);
        }
      }
    };

    fetchAndCheckWords();
  }, [userWords, dispatch, userAttributes.sub]);

  const handleAddWords = () => {
    setShowNoWordsModal(false); // Close the modal
    navigate("/vocabularyDashboard"); // Navigate to the Vocabulary Dashboard
  };
  // If the active exercise is "word-translation", render the WordTranslation component
  let exercise;

  switch (activeExercise) {
    case "word-translation":
      exercise = <WordTranslation />;
      break;

    case "translation-word":
      exercise = <TranslationWord />;
      break;

    case "words-sprint":
      exercise = <Sprint />;
      break;

    case "word-constructor":
      exercise = <Wordonstructor />;
      break;

    default:
      exercise = null;
      break;
  }

  // If an exercise is active, render it
  if (exercise) {
    return exercise;
  }

  return (
    <div className="d-flex flex-nowrap pt-2">
      <Container>
        <Row>
          <Col md={1}></Col>
          <Col md={10}>
            <h1 className="text-center">Select an Exercise</h1>{" "}
            {/* Page title */}
          </Col>
          <Col md={1}></Col>
        </Row>
        <Row className="g-3" style={{ minHeight: "300px" }}>
          {/* Button to select "Word - Translation" exercise */}
          <Col
            xs={6}
            sm={6}
            md={4}
            lg={3}
            className="d-flex align-items-center justify-content-center"
          >
            <Button
              variant="primary"
              size="lg"
              className="w-100 exercise-btn"
              style={{ height: "auto", aspectRatio: "1/1" }} // Maintain square aspect ratio
              onClick={() => dispatch(setActiveExercise("word-translation"))} // Set active exercise to "word-translation"
            >
              Word - Translation
            </Button>
          </Col>
          {/* Button to select "Translation - Word" exercise */}
          <Col
            xs={6}
            sm={6}
            md={4}
            lg={3}
            className="d-flex align-items-center justify-content-center"
          >
            <Button
              variant="primary"
              size="lg"
              className="w-100 exercise-btn"
              style={{ height: "auto", aspectRatio: "1/1" }} // Maintain square aspect ratio
              onClick={() => dispatch(setActiveExercise("translation-word"))}
            >
              Translation - Word
            </Button>
          </Col>
          {/* Placeholder button for Exercise #3 */}
          <Col
            xs={6}
            sm={6}
            md={4}
            lg={3}
            className="d-flex align-items-center justify-content-center"
          >
            <Button
              variant="primary"
              size="lg"
              className="w-100 exercise-btn"
              style={{ height: "auto", aspectRatio: "1/1" }} // Maintain square aspect ratio
              onClick={() => dispatch(setActiveExercise("words-sprint"))}
            >
              Word's Sprint
            </Button>
          </Col>
          {/* Placeholder button for Exercise #4 */}
          <Col
            xs={6}
            sm={6}
            md={4}
            lg={3}
            className="d-flex align-items-center justify-content-center"
          >
            <Button
              variant="primary"
              size="lg"
              className="w-100 exercise-btn"
              style={{ height: "auto", aspectRatio: "1/1" }} // Maintain square aspect ratio
              onClick={() => dispatch(setActiveExercise("word-constructor"))}
            >
              Word Constructor
            </Button>
          </Col>
        </Row>
      </Container>

      {/* Modal for No Words */}
      <Modal show={showNoWordsModal} backdrop="static" centered>
        <Modal.Header>
          <Modal.Title>No Words Found</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          You have no words in your vocabulary. Please add some words to start
          practicing.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleAddWords}>
            Add some words
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
